<template>
    <div class="land-contacts">
        <div class="container">
            <div class="section-title">
                <h2>{{salesCard.contacts_section_title}}</h2>
            </div>
            <div class="contacts-city-filter" id="sales-land-contacts-city-filter">
                <ul>
                    <li v-for="(item, index) in salesCard.office_card" :key="index"> 
                        <a href="#" @click.prevent="filterCards(item.city.slug)" :class="{active : cityActive === item.city.slug}">{{item.city.name}}</a>
                    </li>
                    <li key="all-offices" class="all-offices" v-if="salesCard.contacts_init_btn_all != null && salesCard.contacts_init_btn_all == 'true'"> 
                        <a href="https://sales.bazis.kz/contacts" target="_blank">
                            <span v-if="globalLang != 'kz/'">Все офисы продаж</span>
                            <span v-else>Барлық сату кеңселері</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="contacts-map-container">
                <div class="col-left">
                    <div class="office-item" v-if="officeCard != null">
                        <div class="office-info office-adres">
                            <svgIcon name="pin" />
                            <div class="info">
                                <strong>{{officeCard.office_name}}</strong>
                                <p><span v-for="(desc, index) in officeCard.adres" :key="index">{{desc.desc}}</span></p>
                            </div>
                        </div>
                        <div class="office-info office-phone">
                            <svgIcon name="mobile" />
                            <div class="info">
                                <strong>
                                    <span v-if="globalLang != 'kz/'">Контактный телефон:</span>
                                    <span v-else>Байланыс телефоны:</span>
                                </strong>
                                <p><a :href="'tel:' + officeCard.phone_number" :class="'ringo-' + officeCard.city.slug">{{officeCard.phone_number}}</a></p>
                            </div>
                        </div>
                        <div class="office-info office-time">
                            <svgIcon name="clock" />
                            <div class="info">
                                <strong>
                                    <span v-if="globalLang != 'kz/'">Режим работы:</span>
                                    <span v-else>Жұмыс тәртібі:</span>
                                </strong>
                                <p v-for="(desc, index) in officeCard.work_time" :key="index">{{desc.day}}<span class="red">{{desc.time}}</span></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="sales-land-map-container" id="sales-land-map-container">
                        <div class="map" id='YmapContactsLand' v-if="mapVisible"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sale-land-contacts',
        components: {
            svgIcon,
        },
        data () {
            return {
                mainURL: window.host,
                globalLang: window.GlobalLang, 
                cityActive: '',
                officeCard: null,
                zoom: 16,
                markerLat: null,
                markerLng: null,
                animateMap: true,
                mapVisible: true,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            filterCards(city) {
                // console.log(city, 'asdasdasdasdasd')
                this.cityActive = city;
                this.mapVisible = false;
                var data = this.salesCard.office_card;
                var filteredItems = data.filter(item => {
                    return item.city.slug == city
                });
                if (filteredItems.length)
                this.officeCard = filteredItems[0];
                setTimeout(() => {
                    this.initMapContacts();
                    this.mapVisible = true;
                }, 150);
            },
            initMapContacts() {
                const _self = this;
                this.$loadScript("https://api-maps.yandex.ru/2.1.75/?apikey=5ec4cf69-f505-4a8a-8b6d-70d1e6402870&lang=ru_RU")
                .then(() => {
                    // console.log('inside map')
                    var marker = this.salesCard.map_marker;
                    var zoom = this.zoom;
                    var Ymap = null;
                    var myPlacemark;
                    ymaps.ready().then(function() {
                        var initMap = function() {
                            Ymap = new ymaps.Map('YmapContactsLand', {
                                center: [_self.officeCard.office_map_lng, _self.officeCard.office_map_lat],
                                zoom: zoom,
                                controls: ['fullscreenControl', 'zoomControl'],
                                behaviors: ["drag", "rightMouseButtonMagnifier", "multiTouch"]
                            },{suppressMapOpenBlock: true, minZoom: 3, maxZoom: 20, yandexMapDisablePoiInteractivity: true});
                            var buildMainPin = function() {
                                var lng = _self.officeCard.office_map_lat,
                                    lat = _self.officeCard.office_map_lng;
                                myPlacemark = new ymaps.Placemark([lat, lng], {}, {
                                    iconLayout: 'default#image',
                                    iconImageHref: marker,
                                    iconImageSize: [80, 90],
                                    iconImageOffset: [-20, -50]
                                });
                                Ymap.geoObjects.add(myPlacemark);
                            };
                            buildMainPin()
                        };
                        initMap();
                    });
                })
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.filterCards(this.salesCard.city_name.slug);
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-contacts.scss';
    @import '@/styles/components/sales/respond/land-contacts-respond.scss';
</style>